import { Predicates } from "../../../libraries/predicates/predicates";
import { MasterArtworkNameState } from "../../../states/meta-artwork/artwork-name/data.type";

export const formatArtworkNameOptions = (
  item: MasterArtworkNameState | null,
) => {
  return Predicates.isNotNullAndNotUndefined(item)
    ? {
        value: item,
        label: `${item.code} - ${item.name}`,
      }
    : null;
};

export const getArtworkName = (artworkNames: MasterArtworkNameState[]) =>
  artworkNames
    .map(formatArtworkNameOptions)
    .filter(Predicates.isNotNullAndNotUndefined);
